import { Permission } from "@edgetier/types";
import { IndexRouteObject, LazyRouteFunction, NonIndexRouteObject, RouteObject } from "react-router-dom";
import type { FeatureToggles } from "redux/modules/setup/setup.types";

export enum PageNames {
    Actions = "Actions",
    AgentHome = "AgentHome",
    Authenticate = "Authenticate",
    AuthenticatedRedirect = "AuthenticatedRedirect",
    CallbackOAuth = "CallbackOAuth",
    CallWallboard = "CallWallboard",
    CreateEmail = "CreateEmail",
    Chat = "Chat",
    DeferredQueries = "DeferredQueries",
    Login = "Login",
    Main = "Main",
    Email = "Email",
    QueryHistory = "QueryHistory",
    Permissions = "Permissions",
    ProactiveChat = "ProactiveChat",
    Reporting = "Reporting",
    ReportingAgents = "ReportingAgents",
    ReportingChat = "ReportingChat",
    ReportingHistoric = "ReportingHistoric",
    ReportingQueue = "ReportingQueue",
    ReportingPublicChat = "ReportingPublicChat",
    ReportingPublicEmail = "ReportingPublicEmail",
    ReportingReports = "ReportingReports",
    ReportingReportsNew = "ReportingReportsNew",
    ReportingReportsEdit = "ReportingReportsEdit",
    ReportingReportsCopy = "ReportingReportsCopy",
    ReportingReportsDisplay = "ReportingReportsDisplay",
    Search = "Search",
    SearchQueries = "SearchQueries",
    SearchInteractions = "SearchInteractions",
    Settings = "Settings",
    SettingsBans = "SettingsBans",
    SettingsBrands = "SettingsBrands",
    SettingsChatWidgetAppearances = "SettingsChatWidgetAppearances",
    SettingsDepartments = "SettingsDepartments",
    SettingsEmailAccounts = "SettingsEmailAccounts",
    SettingsEmailRoutingRules = "SettingsEmailRoutingRules",
    SettingsForms = "SettingsForms",
    SettingsFormsEdit = "SettingsFormsEdit",
    SettingsIntroductionMessages = "SettingsIntroductionMessages",
    SettingsLanguages = "SettingsLanguages",
    SettingsLogicFlows = "SettingsLogicFlows",
    SettingsLogicFlow = "SettingsLogicFlow",
    SettingsSetups = "SettingsSetups",
    SettingsSkills = "SettingsSkills",
    SettingsSystem = "SettingsSystem",
    SettingsThemes = "SettingsThemes",
    SettingsUserStates = "SettingsUserStates",
    SettingsTextLocalisations = "SettingsTextLocalisations",
    SettingsTextLocalisationsEdit = "SettingsTextLocalisationsEdit",
    SettingsEmailContentTemplates = "SettingsEmailContentTemplates",
    SettingsEmailContentTemplatesBrand = "SettingsEmailContentTemplatesBrand",
    SettingsEmailContentTemplatesEdit = "SettingsEmailContentTemplatesEdit",
    Templates = "Templates",
    Users = "Users",
    NoMatch = "NoMatch",
}

export interface IIndexRouteConfig extends IndexRouteObject {
    path?: RouteObject["path"];
    index: true;
    lazy?: LazyRouteFunction<any>;
    loader?: RouteObject["loader"];
    handle?: IRouteHandle;
    initialProperties?: Record<string, any>;
    isRoute?: boolean;
    children?: undefined;
    permission?: unknown; // TODO: find correct type for this.
}

export interface INonIndexRouteConfig extends Omit<NonIndexRouteObject, "children"> {
    index?: false;
    path?: RouteObject["path"];
    lazy?: LazyRouteFunction<any>;
    loader?: RouteObject["loader"];
    handle?: IRouteHandle;
    initialProperties?: Record<string, any>;
    isRoute?: boolean;
    children?: IRouteHierarchy;
    permission?: unknown; // TODO: find correct type for this.
}

export type IRouteConfig = IIndexRouteConfig | INonIndexRouteConfig;

type IEnabledBasicConfiguration = {
    validation: () => boolean;
};

type IEnabledFeatureToggleConfiguration = {
    featureToggleKey: FeatureToggles;
    validation: (value?: any) => any;
};

type IEnabledConfiguration = IEnabledFeatureToggleConfiguration | IEnabledBasicConfiguration;

export type IRouteHandleEnabledValue = IEnabledConfiguration | Array<IEnabledConfiguration>;

export type IRouteHandle = {
    permission?: Permission | Permission[];
    enabled?: IRouteHandleEnabledValue;
};

export type IRouteHierarchy = {
    [routeName in PageNames]?: IRouteConfig;
} & { [keys: string]: IRouteConfig };
